Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'video-chat',
      overlay: true
    });
  }

  async onActive() {
    await this._loadDailycoApi();
    if (Views.current != this) return;

    const state = this.getState();
    const url = state.url ? state.url : state; // Backward compatibility
    const parameters = Utils.getUrlParams(url);

    if (parameters['asktech_screensharing']) {
      // Do something when only screensharing is requested
    }

    // If an existing Daily callFrame exists in the widget window and is joined, reuse it
    const widgetWindow = Dom.get('widget').window;
    const existingFrame = widgetWindow && widgetWindow.callFrame;
    let reused = false;

    if (existingFrame && typeof existingFrame.meetingState === 'function') {
      let ms = null;
      try { ms = existingFrame.meetingState(); } catch(e) { ms = null; }
      if (ms && /joined|joining|loaded|loading/i.test(String(ms))) {
        // Reuse: just ensure container exists and move the iframe into it
        this.setContent(`<div class=\"slaask-video-container\"></div>`);
        const container = this.element.querySelector('.slaask-video-container');
        if (existingFrame.iframeEl && container && existingFrame.iframeEl.parentElement !== container) {
          container.appendChild(existingFrame.iframeEl);
        }
        reused = true;
      }
    }

    if (!reused) {
      this.setContent(`<div class=\"slaask-video-container\"></div>`);
      this._addDailycoFrame(url, !!parameters['asktech_screensharing']);
    }

    this.once('leave', () => {
      // Do not tear down the video on simple view leave; keep the call running
      // The call will be ended by Daily UI or explicit app action
    })
  }

  chatInput() {
    return false;
  }

  mainTitle() {
    return Wording.video_chat_with + this.app._support_name;
  }

  smallTitle() {
    return Wording.back_to_quit;
  }

  initEventListeners() { }

  _htmlBase() {
    return ``;
  }

  _loadDailycoApi() {
    return new Promise((resolve, reject) => {
      // The script and the iframe need to be in the same window
      const widgetWindow = Dom.get('widget').window;
      if (widgetWindow.DailyIframe) resolve(widgetWindow.DailyIframe);
      else {
        const loadingScript = widgetWindow.document.body.querySelector('script[src="https://unpkg.com/@daily-co/daily-js"]');
        if (loadingScript) { // DailyIframe not available but script present
          loadingScript.addEventListener('load', () => {
            resolve(widgetWindow.DailyIframe);
          });
        }
        else {
          const script = widgetWindow.document.createElement('script');
          script.setAttribute('crossorigin', 'anonymous');
          script.src = 'https://unpkg.com/@daily-co/daily-js';
          script.addEventListener('load', () => {
            resolve(widgetWindow.DailyIframe);
          });
          widgetWindow.document.body.appendChild(script);
        }
      }
    });
  }

  _addDailycoFrame(url, screensharing = false) {
    const widgetWindow = Dom.get('widget').window;
    const container = this.element.querySelector('.slaask-video-container');
    let lang = (this.app._language || 'en').split('-')[0];
    const supportedLanguages = ["de", "en", "es", "fi", "fr", "it", "jp", "ka", "nl", "pl", "pt", "sv", "tr"];
    if (!~supportedLanguages.indexOf(lang)) {
      lang = 'en';
    }
    const callFrame = widgetWindow.DailyIframe.createFrame(container, {
      iframeStyle: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        border: '0',
      },
      showFullscreenButton: true,
      lang: lang
    });
    callFrame.join({ url: url });
    callFrame.on('loaded', () => {
      if (screensharing) {
        callFrame.startScreenShare();
        const stopVideoHanler = event => {
          if (event.participant.local) {
            if (event.participant.video) {
              callFrame.updateParticipant('local', {
                setVideo: false
              });
            }
            callFrame.off('participant-updated', stopVideoHanler);
          }
        };
        callFrame.on('participant-updated', stopVideoHanler);
      }
    });
    window.top.callFrame = callFrame;
  }

});
